// src/components/media360/ui/CopyButton.jsx
import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

async function safeCopy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}

export function CopyButton({
  value,
  label = "Copiar",
  icon = "copy",
  size = "tiny",
  disabled = false,
  basic = true,
  color,
}) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    if (!value) return;
    const ok = await safeCopy(String(value));
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 900);
    }
  };

  return (
    <Button
      size={size}
      basic={basic}
      color={color}
      disabled={disabled || !value}
      onClick={onCopy}
      title={value ? String(value) : ""}
    >
      <Icon name={copied ? "check" : icon} />
      {copied ? "Copiado" : label}
    </Button>
  );
}
